import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { deleteDomain, listDomains, domainState, resetDeletedDomain } from '../domainSlice';


interface Props {
    children?: React.ReactNode;
    item?: any;
}
const ConfirmDeleteDomainModal = (props: Props) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const dispatch = useAppDispatch();

    const confirmAction = () => {
        const domainName = props?.item.domain;
        const team = props?.item.id;
        if (domainName && team) {
            dispatch(deleteDomain({ domainId: domainName, team }))
        }
    };

    const { deletedDomain } = useAppSelector(domainState);

    useEffect(() => {
        if (deletedDomain.isSuccess || deletedDomain.isError) {
            dispatch(resetDeletedDomain());
            dispatch(listDomains());
            handleClose();
        }
    }, [deletedDomain, dispatch]);

    return (
        <>
            <div onClick={handleShow}>{props?.children}</div>
            <Modal centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Domain</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {deletedDomain.isLoading && < SmashSpinner />}
                    {!deletedDomain.isLoading &&
                        <div>
                            Are you sure to delete the following domain ?
                            <p>
                                <code>{props?.item.domain}</code>
                            </p>
                        </div>}

                </Modal.Body>
                {!deletedDomain.isLoading && <Modal.Footer>
                    <Button onClick={handleClose} variant='light'>No</Button>
                    <Button onClick={confirmAction}>Yes</Button>
                </Modal.Footer>}
            </Modal>
        </>
    )
}

export default ConfirmDeleteDomainModal